import downloadReportActions from '../actionTypes/downloadReportActions';

const initialState = {
  isLoading: true,
};

const downloadReportReducer = (state = initialState, action) => {
  switch (action.type) {
    case downloadReportActions.downloadReport:
      return { ...state, isLoading: true };
    case downloadReportActions.downloadReportSuccess:
      return { ...state, isLoading: false };
    case downloadReportActions.downloadReportFailed:
      return { ...state, isLoading: false };
    default:
      return state;
  }
};

export default downloadReportReducer;
